import createReactComponent from '../createReactComponent';
export default createReactComponent('wifi-1', 'IconWifi1', [
  ['path', { d: 'M12 18l.01 0', key: 'svg-0' }],
  ['path', { d: 'M9.172 15.172a4 4 0 0 1 5.656 0', key: 'svg-1' }],
]);
